<template>
  <b-container fluid>
    <b-row class="mb-2 my-1">
      <b-col cols="3">
      <h1 class="my-3">Pack & Ship</h1>
      </b-col>
      <b-col cols="6">
        <Order :ui="this.ui" :loading="this.ui.loaders.order" @fetch-order="fetchOrder()" @combine-order="combineOrder()" />
      </b-col>
      <b-col cols="3">
        <b-card header="Orders" class="text-center">
          <b-badge v-for="order in this.ui.orders" :key="order">{{order}}</b-badge>
        </b-card>
      </b-col>
    </b-row>

    <b-form-row class="mb-2">
      <b-col cols="4">
        <Delivery :ui="this.ui" :loading="this.ui.loaders.order" />
      </b-col>
      <b-col cols="8">
        <Items :items="this.ui.items" :specials="this.ui.specials" :loading="this.ui.loaders.order" :invalidItems="invalidItems"/>
      </b-col>
    </b-form-row>

    <b-form-row>
      <b-col cols="6">
      <Packages
        :items="this.ui.items"
        :packages="this.ui.packages"
        :loading="this.ui.loaders.order"
        :invalid="this.invalidItems.length > 0"
        :shipment_ids="this.ui.shipment_ids"
        ref="packager" />
      </b-col>
      <b-col cols="6">
        <Rates
          :loading="this.ui.loaders.order"
          :packages="this.ui.packages"
          :rates="this.ui.rates"
          :destination="this.ui.address"
          :invalid="this.ui.packages.length == 0 || this.invalidPackages.length > 0"
          :shipment_ids="this.ui.shipment_ids"
          ref="rates"
        />
      </b-col>
    </b-form-row>

  </b-container>
</template>

<script>
import axios from 'axios';

import Order from './Order';
import Items from './Items';
import Packages from './Packages';
import Rates from './Rates';
import Delivery from './Delivery';

export default {
  name: "PackAndShip",
  components: {
    Order,
    Items,
    Packages,
    Rates,
    Delivery,
  },
  computed: {
    invalidItems() {
      return this.ui.items.filter( (i) => {
        if(!!i.special && i.special[0] == 'multipack') {
          return false;
        } else {
          return !(
            (!!i.weight && i.weight > 0) &&
            i.dimensions.reduce((a,v) => a && (!!v && v > 0), true)
          )
        }
      });
    },
    invalidPackages() {
      return this.ui.packages.filter( (i) => { return !( (!!i.weight && i.weight > 0) && i.dimensions.reduce((a,v) => a && (!!v && v > 0), true) ) });
    },
  },
  mounted() {
    if(this.$route.query.orderNumber) {
      this.fetchOrder();
    }
  },
  watch: {
    order() {
      if (!!this.order.shipTo) {
        this.ui.address = this.order.shipTo;
      } else {
        this.ui.address = {}
      }
      this.ui.items = this.getCleanedItems();
      setTimeout( () => this.$refs.packager.repack(), 1000);
    },
    'ui.packages': {
      handler() {
        while(this.ui.rates.length > 0) { this.ui.rates.pop(); }
      },
      deep: true

    },
    'ui.items': {
      handler() {
        this.invalidItems();
        while(this.ui.packages.length > 0) { this.ui.packages.pop(); }
      },
      deep: true
    },
  },
   methods: {
    fetchOrder() {
      while(this.ui.orders.length > 0) { this.ui.orders.pop(); }
      this.ui.loaders.order = true;
      WorkareaService.getSalesOrder(this.ui.order_id).then( r => {
        this.order = r;
        this.ui.loaders.order = false;
        this.ui.orders.push(this.ui.order_id.toUpperCase());
        this.ui.order_id = '';
        this.ui.specials = [];
        // this.$router.push({path: 'pack-and-ship', query: {}})
        // this.$router.push({path: 'pack-and-ship', query: { orderNum: this.ui.orders[0]}});
      });
    },
    combineOrder() {
      WorkareaService.getSalesOrder(this.ui.order_id).then( r => {
        const items = r.rawSalesOrderItems.map( i => {
          let sku = i.sku;
          let id = i.product_id;
          let details = i.product_attributes.details.en;
          let weight = 0;
          let dimensions = [];
          if(details['weight_oz_' + sku]) {
            weight = details['weight_oz_' + sku][0] / 16.0;
          } else if(details['weight_oz']) {
            weight = details['weight_oz'][0] / 16.0;
          } else {
            weight = 9999999;
          }

          if(details['dimensions_in_' + sku]) {
            dimensions = details['dimensions_in_' + sku];
          } else if(details['dimensions_in']) {
            dimensions = details['dimensions_in'];
          } else {
            dimensions = [9,12,12];
          }

          if (typeof dimensions[0] == 'string') {
            dimensions = dimensions.map((x) => {
              return x.replace(/\s+/g, '');
            })
          }

          this.ui.specials.push(details['ship-special']);

          this.ui.items.push({
            sku: sku,
            quantity: i.quantity,
            weight: weight,
            dimensions: dimensions,
            special: details['ship-special'],
          });
        } );
        this.ui.orders.push(this.ui.order_id.toUpperCase());
        this.ui.order_id = '';
        // this.$router.push({path: 'pack-and-ship', query: {}})
        // this.$router.push({path: 'pack-and-ship', query: { orderNum: this.ui.orders[0], combinedOrder: this.ui.orders.slice(1) }})
        // console.log(this.$route.query.combinedOrder);
          setTimeout( () => this.$refs.packager.repack(), 1000);
      });
    },
    getCleanedItems() {
      if(this.order.rawSalesOrderItems) {
        const items = this.order.rawSalesOrderItems.map( i => {
          let sku = i.sku;
          let id = i.product_id;
          let details = {};
          if(i.product_attributes && i.product_attributes.details) {
            details = i.product_attributes.details.en;
          }
          let weight = 0;
          let dimensions = [];
          if(i.blank_item) {
            weight = i.product_attributes.weight / 16;
            dimensions = [9,12,12];
          } else {
            if(details['weight_oz_' + sku]) {
              weight = details['weight_oz_' + sku][0] / 16.0;
            } else if(details['weight_oz']) {
              weight = details['weight_oz'][0] / 16.0;
            } else {
              weight = 0;
            }

            if(details['dimensions_in_' + sku]) {
              dimensions = details['dimensions_in_' + sku];
            } else if(details['dimensions_in']) {
              dimensions = details['dimensions_in'];
            } else {
              dimensions = [9,12,12];
            }

            if (typeof dimensions[0] == 'string') {
              dimensions = dimensions.map((x) => {
                return x.replace(/\s+/g, '');
              })
            }
          }

          let special = null;

          if(details[`ship-special_${sku}`]) {
            special = details[`ship-special_${sku}`]
          } else if(details[`ship-special`]) {
            special = details[`ship-special`]
          }

          if(special) {
            this.ui.specials.push(special)
          }

          return {
            sku: sku,
            quantity: i.quantity,
            weight: weight,
            dimensions: dimensions,
            special: special,
            value: i.total_price.cents / 100,
            id: id,
          }
        } );
        this.ui.items = items;
        return items;
      } else {
        return [];
      }
    },
  },
  data() {
    return {
      ui: {
        order_id: this.$route.query.orderNumber,
        orders: [],
        address: {
          street1: '1900 E NORTH ST',
          street2: '',
          city: 'KOKOMO',
          state: 'IN',
          postal_code: '46901',
          country: 'US',
        },
        items: [],
        specials: [],
        packages: [],
        rates: [],
        loaders: {
          order: false,
          rates: false,
        },
        shipment_ids: [],
      },
      order: {},
    };
  },

}
</script>

<style>
  .card-loader {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(128,128,128,0.75);
    z-index: 100000;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/pack-and-ship/PackAndShip.vue